
export function renderGenaiAiops () {
  return(
  <div className="text-slate-900 dark:text-slate-100 font-display flex flex-col transition-colors duration-300">
    
    {/* Inline custom styles copied from original */}
    <style>{`
      ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
      }
      ::-webkit-scrollbar-track {
          background: #e5e7eb;
      }
      .dark ::-webkit-scrollbar-track {
          background: #050505;
      }
      ::-webkit-scrollbar-thumb {
          background: #94a3b8;
          border-radius: 4px;
      }
      .dark ::-webkit-scrollbar-thumb {
          background: #1e3a3f;
      }
      .dark ::-webkit-scrollbar-thumb:hover {
          background: #2c555c;
      }

      .glass-panel {
          background: rgba(255, 255, 255, 0.6);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border: 1px solid rgba(0, 0, 0, 0.08);
      }

      .dark .glass-panel {
          background: rgba(16, 31, 34, 0.6);
          border: 1px solid rgba(255, 255, 255, 0.08);
      }

      .neon-glow {
          box-shadow: 0 0 15px rgba(13, 204, 242, 0.15);
      }
    `}</style>

    <main className="py-10">

      {/* Breadcrumbs */}
      <nav className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400 mb-8 font-mono">
        <a className="hover:text-primary transition-colors" href="#">Platform</a>
        <span className="material-symbols-outlined text-sm">chevron_right</span>
        <a className="hover:text-primary transition-colors" href="#">Netraa AIOps</a>
        <span className="material-symbols-outlined text-sm">chevron_right</span>
        <span className="text-primary font-medium">Gen-AI Driven Interpretive Intelligence</span>
      </nav>

      {/* Hero Section */}
      <section className="mb-16 relative" id="paradigm-shift">
  <div className="absolute -top-20 -left-20 w-96 h-96 bg-primary/10 rounded-full blur-[100px] pointer-events-none"></div>

  {/* FULL-WIDTH HEADING */}
  <div className="mb-8 text-center xl:text-left mx-auto">
    <h1 className="text-5xl lg:text-5xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
      GenAI Interpretive Intelligence: <br />
      <span className="text-black dark:text-white">
        A Paradigm Shift Beyond Dashboards
      </span>
    </h1>
  </div>

  {/* FLEX ROW FOR LEFT + RIGHT */}
  <div className="flex flex-col xl:flex-row gap-12 items-center">
    {/* LEFT SIDE */}
    <div className="flex-1 z-10">
      {/* Badge + Buttons */}
      <p className="text-lg text-slate-600 dark:text-slate-300 leading-relaxed mb-8 mx-auto">
      Stop manually parsing charts. Netraa synthesizes complex visual dashboards into coherent,
      natural-language narratives, briefing your team exactly like a senior SRE.
    </p>
    </div>

          {/* RIGHT SIDE */}
          <div className="flex-1 w-full relative">

            <div className="relative w-full aspect-video rounded-xl overflow-hidden border border-slate-300 dark:border-slate-700 bg-slate-100 dark:bg-[#0a1114] shadow-2xl group transition-colors duration-300">
              
              <div className="absolute inset-0 bg-gradient-to-br from-slate-100 via-slate-200 to-slate-100 dark:from-[#0a1114] dark:via-[#112328] dark:to-[#0a1114]"></div>

              <div className="absolute inset-0 flex items-center justify-center p-6">
                <div className="relative w-full h-full flex items-center gap-4">

                  {/* LEFT CHAOS */}
                  <div className="flex-1 h-full flex flex-col gap-2 opacity-60">
                    <div className="h-1/3 bg-white dark:bg-slate-800/50 rounded border border-red-500/30 flex items-end p-2 relative overflow-hidden"></div>

                    <div className="h-1/3 flex gap-2">
                      <div className="w-1/2 bg-white dark:bg-slate-800/50 rounded border border-orange-500/30 p-2">
                        <div className="w-full h-2 bg-orange-500/20 mb-1 rounded"></div>
                        <div className="w-3/4 h-2 bg-orange-500/20 rounded"></div>
                      </div>
                      <div className="w-1/2 bg-white dark:bg-slate-800/50 rounded border border-slate-300 dark:border-slate-600 p-2 grid grid-cols-2 gap-1">
                        <div className="bg-slate-200 dark:bg-slate-700 rounded h-full"></div>
                        <div className="bg-red-500/40 rounded h-full animate-pulse"></div>
                      </div>
                    </div>

                    <div className="h-1/3 bg-white dark:bg-slate-800/50 rounded border border-slate-300 dark:border-slate-600 p-2 flex items-center justify-center">
                      <div className="w-16 h-16 rounded-full border-4 border-t-red-500 border-r-red-500 border-b-slate-300 dark:border-b-slate-700 border-l-slate-300 dark:border-l-slate-700 rotate-45"></div>
                    </div>
                  </div>

                  {/* AI SWEEP */}
                  <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-primary shadow-[0_0_30px_5px_#0dccf2] z-20 animate-[pulse_3s_ease-in-out_infinite]"></div>
                  <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-24 bg-gradient-to-r from-transparent via-primary/20 to-transparent z-10 blur-xl"></div>

                  {/* RIGHT ORDER PANEL */}
                  <div className="flex-1 h-full bg-white/90 dark:bg-slate-900/80 backdrop-blur-md rounded-lg border border-primary/30 p-4 flex flex-col relative z-20 shadow-lg transition-colors duration-300">

                    <div className="flex items-center gap-2 mb-3 border-b border-slate-200 dark:border-white/10 pb-2">
                      <span className="material-symbols-outlined text-primary animate-spin">
                        auto_awesome
                      </span>
                      <span className="text-xs font-mono text-primary uppercase">
                        Netraa Insight
                      </span>
                    </div>

                    <div className="space-y-3 font-mono text-xs">
                      <div className="p-2 bg-red-500/10 border-l-2 border-red-500 rounded-r">
                        <span className="text-red-500 dark:text-red-400 font-bold">
                          CRITICAL:
                        </span>
                        <span className="text-slate-700 dark:text-slate-300">
                          {" "}High latency detected in payment gateway.
                        </span>
                      </div>

                      <div className="text-slate-600 dark:text-slate-400">
                        <span className="text-primary">&gt;</span> Correlation: DB Lock on Table{" "}
                        <span className="text-slate-900 dark:text-white">orders_idx</span>.
                      </div>

                      <div className="text-slate-600 dark:text-slate-400">
                        <span className="text-primary">&gt;</span> Impact: 14% failure rate in checkout.
                      </div>

                      <button className="mt-4 text-xs bg-primary/20 text-primary px-3 py-1.5 rounded border border-primary/30 hover:bg-primary/30 transition-colors w-full text-center">
                        Generate Runbook
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <p className="text-center text-xs text-slate-500 dark:text-slate-500 mt-3 font-mono">
              Figure 1.0: Real-time dashboard interpretation engine
            </p>

          </div>
        </div>
      </section>
<div className="border-t border-slate-200 dark:border-white/10 my-12"></div>

{/* The Problem Section */}
<section className="mb-20 scroll-mt-24" id="dashboard-fatigue">
  <div className="flex flex-col-reverse md:flex-row gap-12 items-center">
    
    {/* Image Panel */}
    <div className="flex-1 w-full">
      <div className="relative rounded-xl overflow-hidden min-h-[300px] 
        border border-red-200 dark:border-red-900/30 
        bg-red-50 dark:bg-[#1a0f0f]">

        <img
          className="absolute inset-0 w-full h-full object-cover 
          opacity-30 dark:opacity-40 
          mix-blend-normal dark:mix-blend-luminosity 
          grayscale contrast-125"
          src="https://lh3.googleusercontent.com/aida-public/AB6AXuCxiJeIIorYXqTnU0JukDN31HPf98rfTggVVk0fZGqAWFz-KDZyiWw4mkXo9Fi6pZqVwOn2AXFWmx1XDaf9B8Xgm2Vj29wi7_3E02xvRts6FG3G7jv6oFDo9zA6NDVxjzPOoiVwigv6eE0YucM6pxwMgioOX1bEhoafsp3KMyN7QVaqoGbWy64g5r6npYbx2EtRnvvJDRYfIBXAYiKWuBiSfVAnllYyJHs8paXYYUBLwftPRslR1HNRsrUAjgdICpv4rm8AIiJCCTY"
          alt="stressed engineer"
        />

        <div className="absolute inset-0 
          bg-gradient-to-r 
          from-white via-transparent to-transparent
          dark:from-background-dark">
        </div>

        <div className="relative z-10 p-8 flex flex-col justify-end h-full min-h-[300px]">
          <div className="bg-red-100 dark:bg-red-500/10 
            border border-red-300 dark:border-red-500/20 
            backdrop-blur-md p-4 rounded-lg max-w-sm">

            <div className="flex items-center gap-2 text-red-600 dark:text-red-400 mb-2">
              <span className="material-symbols-outlined text-lg">warning</span>
              <span className="text-xs font-bold uppercase">
                Cognitive Overload
              </span>
            </div>

            <p className="text-xs text-red-700 dark:text-red-200">
              Alert fatigue sets in after 15 minutes of continuous monitoring.
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* Content Panel */}
    <div className="flex-1">
      <h2 className="text-3xl font-bold 
        text-slate-900 dark:text-white 
        mb-6 flex items-center gap-3">

        <span className="flex items-center justify-center size-10 rounded-full 
          bg-slate-200 dark:bg-slate-800 
          text-slate-600 dark:text-slate-400 
          text-lg font-mono 
          border border-slate-300 dark:border-slate-700">
          ?
        </span>

        The Problem: 
        <span className="text-slate-500 dark:text-slate-400">
          Dashboard Fatigue
        </span>
      </h2>

      <div className="space-y-6 text-slate-700 dark:text-slate-300">
        <p className="leading-relaxed">
          Traditional platforms merely display data. They treat you like a data processor, not an engineer.
        </p>

        <p className="leading-relaxed pl-4 
          border-l-2 border-slate-300 dark:border-slate-700">
          <em className="text-slate-900 dark:text-white">
            "We have 40 dashboards, but when an outage happens, we still don't know where to look."
          </em>
        </p>

        <p className="leading-relaxed">
          Forcing human operators to manually interpret dozens of disconnected charts creates massive cognitive overhead and slows down decision-making (MTTR) when every second counts.
        </p>

        <ul className="space-y-3 mt-4">
          <li className="flex items-center gap-3 text-sm text-slate-600 dark:text-slate-400">
            <span className="material-symbols-outlined text-red-500 dark:text-red-400 text-lg">
              close
            </span>
            Context switching between tools
          </li>

          <li className="flex items-center gap-3 text-sm text-slate-600 dark:text-slate-400">
            <span className="material-symbols-outlined text-red-500 dark:text-red-400 text-lg">
              close
            </span>
            Siloed metrics without correlation
          </li>

          <li className="flex items-center gap-3 text-sm text-slate-600 dark:text-slate-400">
            <span className="material-symbols-outlined text-red-500 dark:text-red-400 text-lg">
              close
            </span>
            Dependence on tribal knowledge
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

        {/* The Solution Section */}
<section
  className="mb-20 scroll-mt-24"
  id="narrative-solution"
>
  <div className="mb-10 text-center mx-auto">
    <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-4">
      The Solution: <br />
      <span className="text-orange-600 dark:text-orange-500">
        From Visual Artifacts to Intelligent Narratives
      </span>
    </h2>

    <p className="text-slate-600 dark:text-slate-400">
      Netraa transforms pixels into meaning through three core capabilities.
    </p>
  </div>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    
    {/* Card 1 */}
    <div className="glass-panel p-6 rounded-xl 
      bg-white dark:bg-transparent
      border border-slate-200 dark:border-white/10
      hover:border-primary/50
      transition-all duration-300 group hover:-translate-y-1">

      <div className="w-12 h-12 rounded-lg 
        bg-blue-100 dark:bg-blue-500/10
        flex items-center justify-center mb-6 
        group-hover:bg-blue-200 dark:group-hover:bg-blue-500/20 transition-colors">
        <span className="material-symbols-outlined text-blue-600 dark:text-blue-400 text-2xl">
          summarize
        </span>
      </div>

      <h3 className="text-lg font-bold 
        text-slate-900 dark:text-white 
        mb-3 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
        1. Dashboard Summarization
      </h3>

      <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed mb-4">
        Holistic context. Identifies key trends and anomalies across all widgets in one natural-language summary.
      </p>

      <div className="bg-slate-100 dark:bg-black/30 
        p-3 rounded text-xs font-mono 
        text-slate-600 dark:text-slate-500 
        border border-slate-200 dark:border-white/5">
        "Summary: Traffic spike correlates with new deployment v2.4..."
      </div>
    </div>

    {/* Card 2 */}
    <div className="glass-panel p-6 rounded-xl 
      bg-white dark:bg-transparent
      border border-slate-200 dark:border-white/10
      hover:border-primary/50
      transition-all duration-300 group hover:-translate-y-1 relative overflow-hidden">

      <div className="absolute top-0 right-0 w-24 h-24 bg-primary/5 rounded-bl-full -mr-4 -mt-4"></div>

      <div className="w-12 h-12 rounded-lg 
        bg-primary/10 dark:bg-primary/10
        flex items-center justify-center mb-6 
        group-hover:bg-primary/20 transition-colors relative z-10">
        <span className="material-symbols-outlined text-primary text-2xl">
          loupe
        </span>
      </div>

      <h3 className="text-lg font-bold 
        text-slate-900 dark:text-white
        mb-3 group-hover:text-primary transition-colors relative z-10">
        2. Granular Tile Inspection
      </h3>

      <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed relative z-10">
        Deep dive on demand. Drill into specific metrics for instant AI interpretation of individual tiles and outliers.
      </p>
    </div>

    {/* Card 3 */}
    <div className="glass-panel p-6 rounded-xl 
      bg-white dark:bg-transparent
      border border-slate-200 dark:border-white/10
      hover:border-purple-500/50
      transition-all duration-300 group hover:-translate-y-1">

      <div className="w-12 h-12 rounded-lg 
        bg-purple-100 dark:bg-purple-500/10
        flex items-center justify-center mb-6 
        group-hover:bg-purple-200 dark:group-hover:bg-purple-500/20 transition-colors">
        <span className="material-symbols-outlined text-purple-600 dark:text-purple-400 text-2xl">
          diversity_3
        </span>
      </div>

      <h3 className="text-lg font-bold 
        text-slate-900 dark:text-white
        mb-3 group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors">
        3. Democratized Observability
      </h3>

      <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
        Translate technical telemetry into plain English, bridging the gap between SREs and business stakeholders.
      </p>
    </div>
  </div>
</section>

{/* CTA Section */}
<section className="relative rounded-2xl overflow-hidden p-8 md:p-12 text-center 
  border border-slate-200 dark:border-white/10
  bg-white dark:bg-transparent">

  <div className="absolute inset-0 
    bg-gradient-to-r 
    from-primary/5 via-purple-500/5 to-primary/5
    dark:from-primary/10 dark:via-purple-500/10 dark:to-primary/10">
  </div>

  <div
    className="absolute inset-0 opacity-5 dark:opacity-10"
    style={{
      backgroundImage: "radial-gradient(currentColor 1px, transparent 1px)",
      backgroundSize: "24px 24px",
    }}
  ></div>

  <div className="relative z-10 mx-auto">
    <h2 className="text-2xl md:text-3xl font-bold 
      text-slate-900 dark:text-white mb-4">
      Transform your dashboards into actionable stories.
    </h2>

    <p className="text-slate-600 dark:text-slate-300 mb-8">
      Reduce MTTR by 40% with GenAI-assisted diagnostics.
    </p>

    {/* <button className="bg-slate-900 dark:bg-white 
      text-white dark:text-slate-900 
      hover:bg-slate-700 dark:hover:bg-slate-200 
      px-8 py-3 rounded-full font-bold 
      shadow-lg shadow-black/10 dark:shadow-white/10 
      transition-all flex items-center gap-2 mx-auto">
      See GenAI in Action
      <span className="material-symbols-outlined">arrow_forward</span>
    </button> */}
  </div>
</section>
      </main>
    </div>
    );
};